module.exports = __webpack_public_path__ + "img/qr-slide-3.f99f9ce0.png";